import { Row, Col, Spin } from "antd";
import StatCard from "components/statCard";
import {
  UserRound,
  Dumbbell,
} from "lucide-react";
import React from "react";

const ReviewsStats = ({ stats, isLoading }) => {

  return (
    <Spin spinning={isLoading}>
      <Row gutter={[12, 12]} className="reviews-stats">
        <Col xs={12} sm={12} md={12}>
          <StatCard
            title={stats?.users ?? 0}
            subtitle="Alunos"
            icon={<UserRound size={18} color="#fff" />}
            iconColor="#2C2C2C"
          />
        </Col>

        <Col xs={12} sm={12} md={12}>
          <StatCard
            title={stats.reviews ?? 0}
            subtitle="Avaliações Efetuadas"
            icon={<Dumbbell size={18} color="#fff" />}
            iconColor="#FDBA63"
          />
        </Col>
      </Row>
    </Spin>
  );
};

export default ReviewsStats;
